import type { OutlookSpaceAsset, TimeStreamAssets } from 'owa-timestream-types';
import findAsset from './findAsset';
import insertAsset from './insertAsset';
import updateAsset from './updateAsset';

export default function upsertAsset(
    assets: TimeStreamAssets,
    outlookSpaceAsset: OutlookSpaceAsset,
    fullSync: boolean
) {
    const possibleAsset = findAsset(assets, outlookSpaceAsset.id);

    const asset = possibleAsset
        ? updateAsset(possibleAsset, outlookSpaceAsset)
        : insertAsset(assets, outlookSpaceAsset);

    if (fullSync) {
        asset.deleted = false;
    }
}
